import React from "react";
// import TextAreaInput from "src/components/Forms/textArea";

import { ActionType } from "..";
import TextAreaInput from "../../../../components/Forms/textArea";
///components/Forms/textArea";

const getActionText = (action: ActionType | "") => {
  switch (action) {
    case ActionType.Approve:
      return "Leave a comment";
    case ActionType.Edit:
      return "Edit your comment";
    case ActionType.Reset:
      return "Are you sure you want to remove your signature?";
    case ActionType.Reject:
      return "Are you sure you want to reject this approval request?";
    default:
      return "";
  }
};

interface IManageApproval {
  action: ActionType | "";
  handleCommentsChange: any;
  comment: string;
}

const ManageApproval = ({
  action,
  handleCommentsChange,
  comment,
}: IManageApproval) => {
  return (
    <>
      <div className="mb-7 text-center text-xl font-semibold">
        {getActionText(action)}
      </div>
      <div className="mb-3">
        <TextAreaInput
          onChange={handleCommentsChange}
          value={comment}
          name={comment}
          placeholder="comment here"
          disabled={action === ActionType.Reset}
        />
      </div>
    </>
  );
};

export default ManageApproval;
